/*
  Анонс с обратным отсчётом в шапке. Чтобы анонсировать следующее событие,
  достаточно поменять значения ниже — из админки блок не управляется.
  После наступления startsAt блок пропадает сам.
*/
export type AnnounceBarConfig = {
  enabled: boolean;
  /* ISO 8601 с оффсетом Москвы (+03:00) */
  startsAt: string;
  link: string;
  label: string;
  /* Имя файла из client/shared/icons без расширения, с fill="currentColor" */
  logo: string;
  /* Ссылка пункта HEADER_MENU_ITEMS, который скрыть, пока блок активен */
  hiddenMenuLink: string;
};

export const ANNOUNCE_BAR: AnnounceBarConfig = {
  enabled: true,
  startsAt: '2026-09-24T17:30:00+03:00',
  link: 'https://cre-awards.ru',
  label: 'До начала церемонии:',
  logo: 'i-cre-awards-logo',
  hiddenMenuLink: 'https://cre-awards.ru',
};
